import { CognitoConfig } from "../models/cognito";

const cognito: CognitoConfig = {
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID ? process.env.REACT_APP_COGNITO_USER_POOL_ID : "",
    clientId: process.env.REACT_APP_COGNITO_CLIENT_ID ? process.env.REACT_APP_COGNITO_CLIENT_ID : "",
};

export default cognito
